<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <v-card
        flat
        width="100%"
        class="login-basic">
        <v-card-title
          class="font-weight-bold pa-0 pb-4">
          <div class="mr-2">
            {{ email }}
            <input type="text" autocomplete="username" :value="email" style="display: none">
          </div>
          <div>
            <v-icon
              v-if="exists"
              class="green--text">
              mdi-check-bold
            </v-icon>
            <span
              v-if="!exists"
              class="blue--text text-caption">
              (nuevo)
            </span>
          </div>
        </v-card-title>
        <!-- password -->
        <ValidationProvider
          mode="eager"
          vid="password"
          name="auth.password"
          rules="required"
          v-slot="{ errors }">
          <v-text-field
            filled
            flat
            :disabled="waiting || !exists"
            :maxlength="100"
            name="email"
            v-model="password"
            :error-messages="errors[0]"
            class="password"
            label="Contraseña"
            type="password"
            autocomplete="password">
          </v-text-field>
        </ValidationProvider>
        <div
          class="mt-1 mb-5">
          <div
            v-if="exists">
            <span>¿Olvidaste tu contraseña?</span>&nbsp;
            <a @click="$emit('reset')">Crea una nueva</a>
          </div>
          <div
            v-if="!exists">
            <span>¿No tienes un usuario?</span>&nbsp;
            <a>Regístrate</a>
          </div>
        </div>
        <v-card-actions
          class="px-0">
          <v-spacer></v-spacer>
          <v-btn
            text
            class="grey--text px-10"
            :disabled="waiting"
            @click="cancel">
            Cancelar
          </v-btn>
          <v-btn
            type="submit"
            class="brand-purple white--text px-10"
            :disabled="!exists"
            :loading="waiting">
            Iniciar sesión
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </ValidationObserver>
</template>

<script>

import { mapActions } from 'vuex';
import Utils from '@/Utils';
import loginController from '@/controllers/Login';

export default {
  name: 'LoginBasic',
  props: {
    email: {
      default: null,
    },
    exists: {
      default: false,
    },
  },
  data() {
    return {
      password: null,
      waiting: false,
    };
  },
  methods: {
    ...mapActions('app/', ['closeLogin']),
    submit() {
      this.waiting = true;
      const { email, password } = this;
      loginController.login(email, password)
        .then(() => {
          Utils.trackEvent('Login');
          // vue login / check auth/index.js -> Vue.use(VueAuth -> response(res)
          // check for an "action" in "state" query param sent by provider
          this.$auth.login({ rememberMe: true, redirect: null });
          // close modal
          this.$nextTick(async () => {
            await this.$waitFor(2000);
            this.closeLogin();
          });
        })
        .catch((e) => {
          this.$error(e);
          this.waiting = false;
        });
    },
    cancel() {
      this.$emit('canceled');
    },
  },
};
</script>

<style lang="scss" scoped>
.login-basic {
  a {
    text-decoration: underline;
  }
}
</style>
